console.log('AboutLiving Data Layer and GTM Snippet Depolyed by asset gtm-and-data-layer-injection.js');
//Set Global variables.
var gtm_container_id = "GTM-KVZ5XNG6"; //Client-side production

var ecommercetrackingtype = "ee";

//Set Arrays
var allVariantIds = []
if (typeof sessionStorage.niddocks_collectionsArray === "undefined") {
    var niddocks_collectionsArray = [];
} else {
    var niddocks_collectionsArray = [];
    niddocks_collectionsArray = sessionStorage.niddocks_collectionsArray;
}
//Set Variables
var niddocks_totalNumberOfCollectionResults, niddocks_actualpagelength, niddocks_numberOfResults, niddocks_totalNumberOfCollectionsPages, niddocks_collection_name, niddocks_collectionnamelowercase, niddocks_originalcollection_name, niddocks_collection_title, niddocks_collections;
//Set Numbers
var niddocks_pageiterator = 1;
var niddocks_product_iterator = 0;
//Set Strings
var niddocks_virtual_page_path = "";
var ga4DataLayerProducts = [];

function injectGtmSnippet(){
    document.addEventListener("DOMContentLoaded", function(){
        //Set Virtual Page Path
        var virtualPagePath = window.location.href.split(window.location.origin)[1];
        if (window.location.href.includes('checkouts') == true) { niddocks_virtual_page_path = meta.page.path; } else { niddocks_virtual_page_path = virtualPagePath;
        }

        //Set Checkout Step
        if (Shopify) {
            if (Shopify.Checkout) {
                if (Shopify.Checkout.step) {
                    sendCheckoutStep();
                }
            }
        }
        // Create a new script element
        var script = document.createElement('script');
        // Add the `data-cfasync` attribute
        script.setAttribute('data-cfasync', 'false');
        // Set the content of the script element
        script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtm_container_id}');`;
        // Append the script element to the end of the head section
        document.head.appendChild(script);

        // Create a new noscript element
        var noscript = document.createElement('noscript');
        // Set the innerHTML of the noscript element
        noscript.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + gtm_container_id + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
        // Insert the noscript element at the top of the body
        document.body.insertBefore(noscript, document.body.firstChild);

    });
}



function gtmDataLayerLocalStorage(){
    //Enhanced Ecommerce Start
    if (ecommercetrackingtype == "ee" && window.location.href.includes('thank_you') == true) {
        console.log("localstorage ecommercetrackingtype is " + ecommercetrackingtype);
        console.log("localstorage taxontotal is " + window.localStorage.taxontotal);
        var i;
        var dataLayerProducts = [];
        var dataLayerProductsList = [];
        var dataLayerItemsList = [];
        var lineItems = Shopify.checkout.line_items;
        var arrayLength = lineItems.length;
        var taxontotal = window.localStorage.taxontotal;
        if (taxontotal == "notax") {
            var totalPrice = parseFloat(Shopify.checkout.subtotal_price);
        } else {
            var totalPrice = parseFloat(Shopify.checkout.total_price);
        }
        var totalTax = parseFloat(Shopify.checkout.total_tax);
        if (Shopify.checkout.discount == null) {
            var couponcode = "";
        } else {
            var couponcode = Shopify.checkout.discount.code;
        }

        if (Shopify.checkout.discounts_amount == null) {
            var discounts_amount = 0;
        } else {
            var discounts_amount = Shopify.checkout.discounts_amount;
        }

        if (Shopify.checkout.shipping_rate == null) {
            totalShipping = 0;
        } else {
            totalShipping = parseFloat(Shopify.checkout.shipping_rate.price);
        }

        if (typeof document.getElementsByClassName('os-order-number')[0] === 'undefined') {
            orderId = "Shopify" + Date.now();
        } else {
            var orderIdText = document.getElementsByClassName('os-order-number')[0].innerText
            if (orderIdText.includes("#") === true){
                var orderIdNumber = orderIdText.split("#");
                var orderId = "#" + orderIdNumber[1];
            } else {
                var orderIdNumber = orderIdText.split(" ");
                var orderId = orderIdNumber[1];
            }

        }

        var ecomm_pagetype = getecomm_pagetype();
        var ecomm_totalvalue = totalPrice;
        var ga4DataLayer = [];

        for (i = 0; i < arrayLength; i++)
        {
            //Read category from SessionStorage
            var sessionStorageVariantId = String(lineItems[i].variant_id);
            var categoryFromSessionStorage = sessionStorage.getItem("variantId" + sessionStorageVariantId);

            if (window.localStorage.skuAsId == "yes") { var skuAsId = true;} else {var skuAsId = false; }
            if (skuAsId === true) {
                var dlProductId = lineItems[i].sku;
            } else {
                var dlProductId = lineItems[i].product_id;
            }

            ga4DataLayerProducts.push({
                item_name: lineItems[i].title,
                item_id: dlProductId,
                affiliation: "Online Store",
                coupon: couponcode,
                currency: Shopify.currency.active,
                index: i + 1,
                price: parseFloat(lineItems[i].price),
                item_brand: lineItems[i].vendor,
                item_category: categoryFromSessionStorage,
                item_variant: lineItems[i].variant_title,
                item_list_name: categoryFromSessionStorage,
                quantity: parseFloat(lineItems[i].quantity)
            });

            dataLayerProducts.push({
                'name': lineItems[i].title,
                'id': dlProductId,
                'sku': lineItems[i].sku,
                'price': parseFloat(lineItems[i].price),
                'brand': lineItems[i].vendor,
                'category': categoryFromSessionStorage,
                'variant': lineItems[i].variant_title,
                'variant_id': lineItems[i].variant_id,
                'id_and_variant_id': lineItems[i].product_id + "_" + lineItems[i].variant_id,
                'quantity': parseFloat(lineItems[i].quantity),
            });

            dataLayerProductsList.push({
                'id': dlProductId,
                'price': parseFloat(lineItems[i].price),
                'quantity': parseFloat(lineItems[i].quantity)
            });

            dataLayerItemsList.push({
                'id': dlProductId,
                'quantity': parseFloat(lineItems[i].quantity),
                'price': parseFloat(lineItems[i].price)

            });

        }
        window.dataLayer = window.dataLayer || [];




        dataLayer.push({
          'event': 'purchase',
          'transaction_id': orderId.toString(), // Ensure transaction ID is a string
          'affiliation': 'Online Store',
          'value': totalPrice - totalShipping , // transaction value without shipping cost
          'tax': totalTax,
          'shipping': totalShipping,
          'currency': Shopify.currency.active, // Your shop's active currency
          'coupon': couponcode, // Coupon code used, if any
          'customerData': {
            email: Shopify.checkout.email,
            first_name: Shopify.checkout.billing_address.first_name,
            last_name: Shopify.checkout.billing_address.last_name,
            street: Shopify.checkout.billing_address.address1,
            postal_code: Shopify.checkout.billing_address.zip,
            city: Shopify.checkout.billing_address.city,
            region: Shopify.checkout.billing_address.province,
            country: Shopify.checkout.billing_address.country,
            phone_number: Shopify.checkout.billing_address.phone
          },
          'items': ga4DataLayerProducts,
          'discount': discounts_amount
        });


        console.log("Enhanced Ecommerce gtmDataLayerLocalStorage finish");
//Enhanced Ecommerce End

    }  else {
        if (window.location.href.includes('thank_you') == true) {
            //Standard Ecommerce Start
            var i;
            var dataLayerProducts = [];
            var lineItems = Shopify.checkout.line_items;
            var arrayLength = lineItems.length;
            //var totalPrice = parseFloat(Shopify.checkout.total_price);
            var taxontotal = window.localStorage.taxontotal;
            if (taxontotal == "notax") {
                var totalPrice = parseFloat(Shopify.checkout.subtotal_price);
            } else {
                var totalPrice = parseFloat(Shopify.checkout.total_price);
            }
            var totalTax = parseFloat(Shopify.checkout.total_tax);
            var ecomm_pagetype = getecomm_pagetype();
            var ecomm_totalvalue = totalPrice;

            if (typeof Shopify.checkout.shipping_rate.price === 'undefined') {
                totalShipping = 0;
            } else {
                totalShipping = parseFloat(Shopify.checkout.shipping_rate.price);
            }

            if (typeof document.getElementsByClassName('os-order-number')[0] === 'undefined') {
                orderId = "Shopify" + Date.now();
            } else {
                var orderIdText = document.getElementsByClassName('os-order-number')[0].innerText
                var orderIdNumber = orderIdText.split("#");
                var orderId = "#" + orderIdNumber[1];
            }

            for (i = 0; i < arrayLength; i++)
            {

                dataLayerProducts.push({
                    'sku': lineItems[i].sku,
                    'name': lineItems[i].title,
                    'price': parseFloat(lineItems[i].price),
                    'quantity': parseFloat(lineItems[i].quantity)
                });

            }

            window.dataLayer = window.dataLayer || []
            dataLayer.push({
                'ecomm_pagetype': ecomm_pagetype,
                'ecomm_totalvalue': ecomm_totalvalue,
                'transactionId': orderId,
                'transactionTotal': totalPrice,
                'transactionTax': totalTax,
                'transactionShipping': totalShipping,
                'transactionProducts': dataLayerProducts
            });
            console.log("Standard gtmDataLayerLocalStorage finish");
//Standard Ecommerce End
        }
    }

    injectGtmSnippet();
}


function gtmAppRun () {
    console.log("gtmDataLayerLocalStorage start");
    gtmDataLayerLocalStorage();

}

//Set Checkout Steps Start
function sendCheckoutStep(){
    var checkoutstep;
    switch (niddocks_virtual_page_path) {
        default:
            checkoutstep = 0;
            break;
        case "/checkout/contact_information":
            checkoutstep = 2;
            break;
        case "/checkout/review":
            checkoutstep = 3;
            break;
        case "/checkout/shipping":
            checkoutstep = 3;
            break;
        case "/checkout/payment":
            checkoutstep = 4;
            break;
        case "/checkout/processing":
            checkoutstep = 5;
    }

    if (checkoutstep > 0) {
        var niddocks_cartArray = JSON.parse(sessionStorage.getItem("niddocks_cartArray"));
        window.dataLayer = window.dataLayer || []
        dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': checkoutstep},
                    'products': niddocks_cartArray
                }
            }
        });

    }
}
//Set Checkout Steps End

// Set Google Ads ecomm_pagetype
function getecomm_pagetype(){
    if (typeof meta !== 'undefined') {
        var ShopifyPageType = meta.page.pageType;
    } else {
        var ShopifyPageType = "other";
    }

    switch (ShopifyPageType) {
        default:
            ecomm_pagetype = "other";
            break;
        case "home":
            ecomm_pagetype = "home";
            break;
        case "product":
            ecomm_pagetype = "product";
            break;
        case "collection":
            ecomm_pagetype = "category";
            break;
        case "page":
            ecomm_pagetype = "page";
            break;
        case "searchresults":
            ecomm_pagetype = "searchresults";
    }

    if (ecomm_pagetype == "other") {

        if (window.location.href.includes('orders') == true) { ecomm_pagetype = "purchase";}
        if (window.location.href.includes('thank_you') == true) { ecomm_pagetype = "purchase";}
        if (window.location.href.includes('cart') == true) { ecomm_pagetype = "cart";}

    }

    if (ecomm_pagetype == "page") {
        if (window.location.href.includes('collection=') == true) { ecomm_pagetype = "category";}
    }



    console.log("page type is " + ecomm_pagetype);
    return ecomm_pagetype;
}





//get feed prefix country code from currency
function getfeed_cc_prefix(){

    var currency = ShopifyAnalytics.meta.currency;
    switch (currency) {
        default:
            feed_cc_prefix = "US";
            break;
        case "USD":
            feed_cc_prefix = "US";
            break;
        case "EUR":
            feed_cc_prefix = "EU";
            break;
        case "CAD":
            feed_cc_prefix = "CA";
            break;
        case "TRY":
            feed_cc_prefix = "TR";
            break;
        case "GBP":
            feed_cc_prefix = "GB";
    }
    console.log("feed_cc_prefix is " + feed_cc_prefix);
    return feed_cc_prefix;
}

if (window.location.href.includes('thank_you') == true || window.location.href.includes('/orders/') == true) { checkoutpage = 1;} else { checkoutpage = 0;}

if (checkoutpage == 1)
// start of checkout page
{
    console.log('checkout page');

} else {


// Start of store pages code



// start of Collections Data Layer
    if (ecommercetrackingtype == "ee") {
//var niddocks_collections;
        if (window.location.href.includes('collection=') == true) { niddocks_collections = 1;} else {
            if (typeof(meta) !== "undefined") {
                if (typeof(meta.page) !== "undefined") {
                    if (typeof(meta.page.pageType) !== "undefined") {
                        if (meta.page.pageType == "collection" || meta.page.pageType == "home" || window.location.href.includes('collection=') == true) { niddocks_collections = 1;} else { niddocks_collections = 0;}
                    }
                }
            }
        }

        if (niddocks_collections == 1)
        {

            //category page add to cart start
            document.addEventListener("DOMContentLoaded", function(){
                const selectors = [
                    '[id^="add-to-cart"]',
                    '[id^="add"]',
                    '[id^="AddToCart"]',
                    '[id^="product-add"]',
                    '[id^="AddToCartText"]',
                    '[class^=".add"]',
                    '[class^=".shg-box-content"]',
                    '[class^="action_button add_to_cart"]',
                    '[data-action="add-to-cart"]',
                    '[class^="ProductForm__AddToCart"]',
                    '[class*="plus-ic"]',
                    '[button]'
                ];

                selectors.forEach(function(selector) {
                    const elements = document.querySelectorAll(selector);
                    elements.forEach(function(element) {
                        element.addEventListener('click', function() {
                            var productindex = document.getElementsByClassName('product_form').length - 1;
                            var productlineItems = JSON.parse(document.getElementsByClassName('product_form')[productindex].dataset.product)
                            if (typeof(document.getElementsByName('id')[productindex].options) !== "undefined") {
                                var selectedvariantindex = document.getElementsByName('id')[productindex].options.selectedIndex;
                                var variantlineItems = productlineItems.variants[selectedvariantindex];
                            } else {
                                var variantlineItems = productlineItems;
                            }
                            console.log('productindex is ' + productindex);
                            console.log('selectedvariantindex is ' + selectedvariantindex);

                            var price = parseFloat(variantlineItems.price) / 100;
                            var currency = ShopifyAnalytics.meta.currency;
                            var Quantity = 1;
                            if (document.getElementById('quantity') !== null) {
                                Quantity = document.getElementById('quantity').value;
                            }
                            if (document.getElementById('Quantity') !== null) {
                                Quantity = document.getElementById('Quantity').value;
                            }
                            Quantity = parseInt(Quantity);

                            //Write Product Category to sessionStorage
                            var sessionsStorageVariantId = "variantId" + String(variantlineItems.id);
                            sessionStorage.setItem(sessionsStorageVariantId, productlineItems.type);

                            window.dataLayer = window.dataLayer || []
                            dataLayer.push({
                              'event': 'add_to_cart',
                              'currency': currency, // Make sure this matches your site's currency code
                              'value': price * Quantity, // Total value of the items added to the cart
                              'items': [{
                                'item_id': productlineItems.id.toString(), // Item's SKU or ID as a string
                                'item_name': productlineItems.title,
                                // 'handle': productlineItems.handle, // GA4 does not have a direct equivalent for 'handle', you may omit or use it as an item variant or category depending on your needs
                                'price': price,
                                'item_category': productlineItems.type,
                                'item_variant': variantlineItems.title, // Variant name
                                'quantity': Quantity
                              }]
                            });

                        });
                    });
                });




            });
//category page add to cart end


//get number of pages in collection.json start
            var collection_id = meta.page.resourceId;


            //var data = [];
            function getNumberOfCollectionsPages (){
                if (typeof sessionStorage.niddocks_collectionsArray  === "undefined" || sessionStorage.niddocks_collectionsArray === "[]"){

                    var url = window.location.protocol + "//" + window.location.host + "/collections.json?limit=250&page=" + niddocks_pageiterator;

                    fetch(url)
                        .then(response => response.json())
                        .then(data => {
                            niddocks_numberOfResults = data.collections.length;


                            if (niddocks_numberOfResults == 250) {
                                niddocks_pageiterator++;
                                getNumberOfCollectionsPages();

                            } else {
                                niddocks_totalNumberOfCollectionResults = (niddocks_pageiterator - 1) * 250 + niddocks_numberOfResults;
                                niddocks_totalNumberOfCollectionsPages = niddocks_pageiterator;
                                niddocks_collectionsArray = niddocks_collectionsArray.concat(data.collections);

                                getCollectionName();

                            }
                            niddocks_collectionsArray = niddocks_collectionsArray.concat(data.collections);


                        })
                        .catch(error => console.error('Error:', error));

                } else {
                    //console.log("get collection name loaded 2");
                    getCollectionName();
                    //console.log("collection name is : " + niddocks_collection_name);
                    //console.log("collection name data from sessionStorage");
                }
            }
//get number of pages in collection.json end

            //get collection name
            function getCollectionName () {
                if (typeof sessionStorage.niddocks_collectionsArray  === "undefined" || sessionStorage.niddocks_collectionsArray === "[]"){
                    sessionStorage.setItem("niddocks_collectionsArray", JSON.stringify(niddocks_collectionsArray));}
                var collection_id = meta.page.resourceId;

                if (window.location.href.includes('collection=') == true) {
                    var urlParams = new URLSearchParams(location.search);
                    var handlefromurl = urlParams.get('collection');
                }

                var obj = [];

                obj = JSON.parse(sessionStorage.getItem("niddocks_collectionsArray"));
                for (var i = 0; i < obj.length; i++){

                    if (typeof meta.page.resourceId == "undefined") {
                        niddocks_collection_name = obj[0].handle;
                        niddocks_originalcollection_name = niddocks_collection_name + "";
                        niddocks_collectionnamelowercase = niddocks_originalcollection_name.toLowerCase();
                        //console.log("collection name from title is " + niddocks_collection_name);
                        getproductsdata();
                        //break;
                    } else {

                        if (window.location.href.includes('collection=') == true) {

                            if (obj[i].handle == handlefromurl){
                                niddocks_collection_name = obj[i].handle;
                                niddocks_collection_title = obj[i].title;
                                // console.log("collection name from resourceId is " + niddocks_collection_name);
                                niddocks_originalcollection_name = niddocks_collection_name + "";
                                niddocks_collectionnamelowercase = niddocks_originalcollection_name.toLowerCase();
                                getproductsdata();
                            }

                        } else {

                            if (obj[i].id == collection_id){
                                niddocks_collection_name = obj[i].handle;
                                niddocks_collection_title = obj[i].title;
                                // console.log("collection name from resourceId is " + niddocks_collection_name);
                                niddocks_originalcollection_name = niddocks_collection_name + "";
                                niddocks_collectionnamelowercase = niddocks_originalcollection_name.toLowerCase();
                                getproductsdata();
                            }
                        }


                    }

                }
            }


            getNumberOfCollectionsPages();

//get collection name end




            function getproductsdata(){
                if (niddocks_product_iterator == 0) {
                    niddocks_product_iterator = 1;
                    var xmlhttp = new XMLHttpRequest();
                    xmlhttp.onreadystatechange = function() {
                        if (this.readyState == 4 && this.status == 200) {
                            var myObj = JSON.parse(this.responseText);
                            var i;
                            var dataLayerProducts = [];
                            var lineItems = myObj.products;
                            var arrayLength = lineItems.length;
                            var currency = ShopifyAnalytics.meta.currency;
                            var topThreeIds = [];
                            var ecomm_pagetype = getecomm_pagetype();
                            console.log('product data fetched');

                            for (i = 0; i < arrayLength; i++)
                            {
                                position = i + 1;
                                dataLayerProducts.push({
                                    'name': lineItems[i].title,
                                    'id': lineItems[i].id,
                                    'price': parseFloat(lineItems[i].variants[0].price),
                                    'brand': lineItems[i].vendor,
                                    'category': lineItems[i].product_type,
                                    'variant': lineItems[i].variants[0].sku,
                                    'list': niddocks_collection_title,
                                    'position': position
                                });

                            }

                            //Start of allIds Array
                            var allIds = [];
                            for (i = 0; i < arrayLength; i++)
                            {
                                allIds.push(lineItems[i].id);
                            }
                            //End of allIds Array

                            //Start of allVariantIds Array
                            for (i = 0; i < arrayLength; i++)
                            {
                                allVariantIds.push(lineItems[i].variants[0].id);
                            }
                            //End of allVariantIds Array

                            //Start of topThreeIds Array
                            if (arrayLength > 3) { arrayLength = 3}
                            for (i = 0; i < arrayLength; i++)
                            {
                                //topThreeIds =  topThreeIds + "," + lineItems[i].id;
                                topThreeIds.push(lineItems[i].id);
                            }
                            //End of topThreeIds Array

                            //Start of topThreeVariantIds Array
                            var topThreeVariantIds = [];
                            if (arrayLength > 3) { arrayLength = 3}
                            for (i = 0; i < arrayLength; i++)
                            {
                                topThreeVariantIds.push(lineItems[i].variants[0].id);
                            }
                            //End of topThreeVariantIds Array


                            window.dataLayer = window.dataLayer || []
                            dataLayer.push({
                                'event': 'CollectionViewed',
                                'googleAdsEventName': 'view_item_list',
                                'items': allIds,
                                'ecomm_pagetype': ecomm_pagetype,
                                'ecommerce': {
                                    'currencyCode': currency,
                                    'impressions': dataLayerProducts
                                },
                                'topThreeIds': topThreeIds,
                                'allIds': allIds,
                                'topThreeVariantIds': topThreeVariantIds,
                                'allVariantIds': allVariantIds
                            });
                        }
                    };
                    xmlhttp.open("GET", window.location.protocol + "//" + window.location.host + "/collections/" + niddocks_collectionnamelowercase + "/products.json", true);
                    xmlhttp.send();
                } else { console.log('product data not fetched');}
            }
        }
    }
// End of Collections Data Layer



// Start of Product Page Data Layer
    if (ecommercetrackingtype == "ee") {
        var productpage;
        if (typeof(meta) !== "undefined") {
            if (meta.page.pageType == "product") { productpage = 1;} else { productpage = 0;}
        }

        if (productpage == 1)
        {


            //Start of Add To Cart
            document.addEventListener("DOMContentLoaded", function(){
                if (ecommercetrackingtype == "ee") {
                    const selectors = [
                        '[id^="add-to-cart"]',
                        '[id^="add"]',
                        '[id^="product-add"]',
                        '[id^="AddToCart"]',
                        '[id^="shopify_add_to_cart"]',
                        '[id^="AddToCart"]',
                        '[id^="AddToCartText"]',
                        '[class^=".add"]',
                        '[class^=".shg-box-content"]',
                        '[class^="so-btn-add-to-cart"]',
                        '[class^="action_button add_to_cart"]',
                        '[data-action="add-to-cart"]',
                        '[class^="ProductForm__AddToCart"]',
                        '[class^="action_button add_to_cart"]',
                        '[class*="plus-ic"]',
                        '[button]'
                    ];

                    selectors.forEach(function(selector) {
                        const elements = document.querySelectorAll(selector);
                        elements.forEach(function(element) {
                            element.addEventListener('click', function() {

                                var xmlhttp = new XMLHttpRequest();
                                xmlhttp.onreadystatechange = function() {
                                    if (this.readyState == 4 && this.status == 200) {
                                        var myObj = JSON.parse(this.responseText);
                                        var lineItems = myObj;
                                        var price = parseFloat(lineItems.price_min) / 100;
                                        var currency = ShopifyAnalytics.meta.currency;
                                        var Quantity = 1;
                                        if (document.getElementById('quantity') !== null) {
                                            Quantity = document.getElementById('quantity').value;
                                        }
                                        if (document.getElementById('Quantity') !== null) {
                                            Quantity = document.getElementById('Quantity').value;
                                        }
                                        Quantity = parseInt(Quantity);

                                        //Get variant query parameter
                                        var urlParams = new URLSearchParams(window.location.search);
                                        var variantId = urlParams.get('variant');
                                        variantId = parseFloat(variantId);
                                        console.log("variant id is " + variantId);
                                        if (variantId === null  || typeof(variantID) == "undefined") {
                                            var variantIndex = 0;
                                            console.log("default variant index is " + variantIndex);
                                        } else {
                                            var variantIndex = lineItems.variants.map(function(e) { return e.id; }).indexOf(variantId);
                                            console.log("variant index is " + variantIndex);
                                        }

                                        //Write Product Category to sessionStorage
                                        var sessionsStorageVariantId = "variantId" + String(lineItems.variants[variantIndex].id);
                                        sessionStorage.setItem(sessionsStorageVariantId, lineItems.type);

                                        window.dataLayer = window.dataLayer || []
                                        dataLayer.push({
                                            'event': 'addToCart',
                                            'googleAdsEventName': 'add_to_cart',
                                            'items': lineItems.id,
                                            'itemsPrice': parseFloat(lineItems.variants[variantIndex].price) / 100,
                                            'ecommerce': {
                                                'currencyCode': currency,
                                                'add': {
                                                    'actionField': {'list': lineItems.type},      // Optional list property.
                                                    'products': [{
                                                        'name':     lineItems.title,
                                                        'id':       lineItems.id,
                                                        'sku':      lineItems.variants[variantIndex].sku,
                                                        'handle':   lineItems.handle,
                                                        'price':    parseFloat(lineItems.variants[variantIndex].price) / 100,
                                                        'category': lineItems.type,
                                                        'quantity': Quantity
                                                    }]
                                                }
                                            }
                                        });
                                    }
                                };
                                xmlhttp.open("GET", window.location.protocol + "//" + window.location.hostname + window.location.pathname + ".js" + window.location.search, true);
                                xmlhttp.send();
                            });
                        });
                    });
                }
            });
            //End of Add To Cart

            var xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    var myObj = JSON.parse(this.responseText);
                    var lineItems = myObj;
                    var price = parseFloat(lineItems.price_min) / 100;
                    var ecomm_pagetype = getecomm_pagetype();
                    var ecomm_totalvalue = price;
                    var product_id = lineItems.id;
                    var product_variant_id = lineItems.variants[0].id;
                    var feed_cc_prefix = getfeed_cc_prefix();
                    var ecomm_prodid = "shopify_" + feed_cc_prefix + "_" + product_id + "_" + product_variant_id;
                    //console.log("product id is " + ecomm_prodid);

                    window.dataLayer = window.dataLayer || []
                    dataLayer.push({
                        'event': 'productPageViewed',
                        'googleAdsEventName': 'view_item',
                        'items': lineItems.id,
                        'itemsPrice': price,
                        'product_image_url': lineItems.featured_image,
                        'compare_at_price': lineItems.variants[0].compare_at_price,
                        'ecomm_pagetype': ecomm_pagetype,
                        'ecomm_prodid': ecomm_prodid,
                        'ecomm_totalvalue': ecomm_totalvalue,
                        'ecommerce': {
                            'detail': {
                                'actionField': {'list': lineItems.type},    // 'detail' actions have an optional list property.
                                'products': [{
                                    'name': lineItems.title,         // Name or ID is required.
                                    'id': lineItems.id,
                                    'handle': lineItems.handle,
                                    'price': price,
                                    'brand': lineItems.vendor,
                                    'category': lineItems.type,
                                    'variant': lineItems.variants[0].name,
                                    'variant_id': lineItems.variants[0].id,
                                    'sku': lineItems.variants[0].sku
                                }]
                            }
                        }
                    });

                }
            };
            xmlhttp.open("GET", window.location.protocol + "//" + window.location.hostname + window.location.pathname + ".js" + window.location.search, true);
            xmlhttp.send();
        }
    }
// End of Product Page Data Layer

    var gtmInsertGTMContainer = function () {
        if (typeof(gtm_container_id) !== "undefined") {
            //Start of Cart Products List
            if (ecommercetrackingtype == "ee") {

                if (window.location.href.includes('/cart') == true) { cartpage = 1;} else { cartpage = 0;}

                if (cartpage == 1)

                {
                    var xmlhttp = new XMLHttpRequest();
                    xmlhttp.onreadystatechange = function() {
                        if (this.readyState == 4 && this.status == 200) {
                            var myObj = JSON.parse(this.responseText);
                            var i;
                            var dataLayerProducts = [];
                            var ecomm_prodids = [];
                            var lineItems = myObj.items;
                            var arrayLength = lineItems.length;
                            var currency = ShopifyAnalytics.meta.currency;
                            var ecomm_pagetype = getecomm_pagetype();
                            var feed_cc_prefix = getfeed_cc_prefix();
                            var ecomm_totalvalue = parseFloat(myObj.total_price) / 100;


                            for (i = 0; i < arrayLength; i++)
                            {

                                dataLayerProducts.push({
                                    'name': lineItems[i].product_title,
                                    'sku': lineItems[i].sku,
                                    'id': lineItems[i].product_id,
                                    'price': parseFloat(lineItems[i].price) / 100,
                                    'brand': lineItems[i].vendor,
                                    'category': lineItems[i].product_type,
                                    'variant': lineItems[i].variant_title,
                                    'variant_id': lineItems[i].variant_id,
                                    'quantity': parseInt(lineItems[i].quantity)
                                });

                                ecomm_prodids.push(
                                    "shopify_" + feed_cc_prefix + "_" + lineItems[i].product_id + "_" + lineItems[i].variant_id
                                );


                            }

                            //Set Cart Session Storage
                            sessionStorage.setItem("niddocks_cartArray", JSON.stringify(dataLayerProducts));

                            window.dataLayer = window.dataLayer || []
                            if (window.localStorage.ecommercetrackingcartstep == 1) {}

                            dataLayer.push({
                                'event': 'viewCart',
                                'ecommerce': {
                                    'checkout': {
                                        'actionField': {'step': 1, 'option': ''},
                                        'products': dataLayerProducts
                                    }
                                },
                                'ecomm_pagetype': ecomm_pagetype,
                                'ecomm_prodid': ecomm_prodids,
                                'ecomm_totalvalue': ecomm_totalvalue,
                                'dataLayerProducts': dataLayerProducts
                            });
                        }
                    };
                    xmlhttp.open("GET", window.location.protocol + "//" + window.location.host + "/cart.js", true);
                    xmlhttp.send();
                }
            }
            //template
            //endof template

            //End of Cart Products List


        }
    }

}


gtmAppRun();
